export default __webpack_public_path__ + "static/media/arrow_tip.13e93ffd.svg";